'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ComponentProvider = function (_Component) {
    (0, _inherits3.default)(ComponentProvider, _Component);

    function ComponentProvider() {
        (0, _classCallCheck3.default)(this, ComponentProvider);
        return (0, _possibleConstructorReturn3.default)(this, (ComponentProvider.__proto__ || (0, _getPrototypeOf2.default)(ComponentProvider)).apply(this, arguments));
    }

    (0, _createClass3.default)(ComponentProvider, [{
        key: 'getChildContext',

        /* eslint-enable react/forbid-prop-types */

        value: function getChildContext() {
            return {
                cms: {
                    localComponentsMapping: this.props.localComponentsMapping
                }
            };
        }
        /* eslint-disable react/forbid-prop-types */

    }, {
        key: 'render',
        value: function render() {
            return _react.Children.only(this.props.children);
        }
    }]);
    return ComponentProvider;
}(_react.Component);

ComponentProvider.propTypes = {
    children: _propTypes2.default.element.isRequired,
    localComponentsMapping: _propTypes2.default.object.isRequired };
ComponentProvider.defaultProps = {
    localComponentsMapping: {}
};
ComponentProvider.childContextTypes = {
    cms: _propTypes2.default.object.isRequired
};
exports.default = ComponentProvider;
//# sourceMappingURL=ComponentProvider.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/component-provider/lib/cjs/ComponentProvider.js
 ** module id = 480
 ** module chunks = 1
 **/